import React from "react";
import { Header } from "../../components/feature/Header";
import { Footer } from "../../components/feature/Footer";
import PageHero from "../../components/ui/PageHero";
import heroTeams from "../../assets/teams-hero.jpg";
import { TeamsGrid } from "./components/TeamsGrid";
import { CoachingStaff } from "./components/CoachingStaff";

export default function EquipesPage() {
  return (
    <>
      <Header />
      <PageHero
        src={heroTeams}
        title="Nos équipes"
        mode="contain-blur"
        heightClass="h-[44vh] md:h-[56vh]"
        focal="50% 35%"
        alt="CSVBV - Nos équipes"
      />
      <main className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          <TeamsGrid />
          <CoachingStaff />
        </div>
      </main>
      <Footer />
    </>
  );
}
